import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { scaleInOut } from '../../animations/scale-in-out.animation';
import { opacityInOut } from '../../animations/opacity-in-out.animation';
import { HelperService } from 'src/app/core/services/helper.service';
import { DomSanitizer } from '@angular/platform-browser';

export const HINTS_LINK = {
  talentProfile: 'User_profile_update__Azeye-3ZQBGRD_LyFhl71A',
  talentSocial: 'Guide_to_Managing_Profile_Links_for_Job_Applications__ryC_BAvjTKWMSRcMq2vAKg',
  talentOnboarding: 'Talent_onboaring_steps__e68NcHPBRY2oWyozU6JWEw',
  talentVacancies: 'How_to_Navigate_and_Explore_Job_Vacancies_and_Company_Information__v5YVstpBS1m9tdC_h4tziQ'
}

@Component({
  selector: 'hint-frame',
  templateUrl: 'hint-frame.component.html',
  styleUrls: ['hint-frame.component.scss'],
  animations: [ opacityInOut, scaleInOut ]
})
export class HintFrameComponent implements OnInit {

  @Input() type = null;
  @ViewChild('iframe') iframe: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.frameHeight = document.documentElement.clientHeight * 0.8;
  }
  frameHeight = document.documentElement.clientHeight * 0.8;
  showFrame = false;
  frameUrl = null;
  loader = false;
  hasPulse = true;

  constructor(
    private helperService: HelperService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.frameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://scribehow.com/embed/${HINTS_LINK[this.type]}?skipIntro=true&removeLogo=true`
    );
    const currentHints = localStorage.getItem('hints');
    if (currentHints) {
      const parsed = JSON.parse(currentHints);
      if (parsed && Array.isArray(parsed) && parsed.includes(this.type)) {
        this.hasPulse = false;
      }
    }
  }

  finishLoad(e) {
    this.loader = false;
  }

  show() {
    if (this.hasPulse) {
      this.hasPulse = false;
      const currentHints = localStorage.getItem('hints');
      if (currentHints) {
        const parsed = JSON.parse(currentHints);
        if (parsed && Array.isArray(parsed) && !parsed.includes(this.type)) {
          localStorage.setItem('hints', JSON.stringify([ ...parsed, this.type ]));
        }
      } else {
        localStorage.setItem('hints', JSON.stringify([ this.type ]));
      }
    }
    this.showFrame = true;
    this.loader = true;
    this.helperService.blockScroll$.next(true);
    setTimeout(() => {
      this.iframe.nativeElement.addEventListener('load', this.finishLoad.bind(this));
    })
  }

  close() {
    this.showFrame = false;
    this.helperService.blockScroll$.next(false);
  }
  
}
